import { Tooltip } from 'radix-ui';
import type { ReactElement, ReactNode } from 'react';

/** Supplemental label on hover/focus. Never the only way to learn what a control does. */
export function Tip({ label, children, side = 'top' }: { label: ReactNode; children: ReactElement; side?: 'top' | 'bottom' | 'left' | 'right' }) {
  return (
    <Tooltip.Root>
      <Tooltip.Trigger asChild>{children}</Tooltip.Trigger>
      <Tooltip.Portal>
        <Tooltip.Content
          side={side}
          sideOffset={8}
          collisionPadding={8}
          className="z-50 max-w-64 rounded-sm bg-ink px-2.5 py-1.5 text-meta font-medium text-canvas shadow-md data-[state=closed]:animate-fade-out data-[state=delayed-open]:animate-fade-in data-[state=instant-open]:animate-fade-in"
        >
          {label}
        </Tooltip.Content>
      </Tooltip.Portal>
    </Tooltip.Root>
  );
}

export const TooltipProvider = Tooltip.Provider;
